export default __webpack_public_path__ + "images/models/641368af177025e545e9402597011e6b.glb";